import ref from 'vue-ref';
import { fcInput } from './fcInputDirective';
import { fcDecorator } from './FormDecoratorDirective';
import { fcPortal } from './portalDirective';

export default {
  install: Vue => {
    Vue.use(ref, { name: 'fc-ref' });
    fcInput(Vue);
    fcDecorator(Vue);
    fcPortal(Vue);
  },
};
